import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useSiteColors } from "./hooks/useSiteColors";
import SEOMeta from "./components/SEOMeta";
import roster from "./rosterData";
import { supabase } from "./supabase";

const F = "'Helvetica Neue', Helvetica, Arial, sans-serif";

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function ArtistTile({ artist, imageUrl }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Link
      to={`/artist/${artist.slug}`}
      style={{ textDecoration: "none", display: "block" }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{
        width: "100%", aspectRatio: "1", overflow: "hidden",
        background: "#0d0d0d", marginBottom: "10px",
      }}>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={artist.displayName || artist.name}
            style={{
              width: "100%", height: "100%",
              objectFit: "cover", objectPosition: "top",
              display: "block",
              transform: hovered ? "scale(1.04)" : "scale(1)",
              transition: "transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)",
            }}
          />
        )}
      </div>
      <p style={{
        fontFamily: F, fontSize: "11px", fontWeight: 700,
        letterSpacing: "0.1em", textTransform: "uppercase",
        color: "#f0ede8", margin: "0 0 3px",
        opacity: hovered ? 1 : 0.75,
        transition: "opacity 0.25s ease",
      }}>
        {(artist.displayName || artist.name).toUpperCase()}
      </p>
    </Link>
  );
}

export default function Roster() {
  const { bg } = useSiteColors();
  const [imageOverrides, setImageOverrides] = useState({});

  useEffect(() => {
    async function fetchOverrides() {
      const { data } = await supabase
        .from("artists")
        .select("slug, profile_image")
        .not("profile_image", "is", null);
      if (data) {
        const map = {};
        data.forEach(a => {
          if (a.slug && a.profile_image?.trim()) map[a.slug] = a.profile_image.trim();
        });
        setImageOverrides(map);
      }
    }
    fetchOverrides();
  }, []);

  const shuffled = useMemo(() => shuffle(roster), []); // eslint-disable-line

  return (
    <div style={{ backgroundColor: bg, minHeight: "100vh", paddingTop: "60px" }}>
      <SEOMeta
        title="Roster"
        description="Meet the artists of YEN SOUND — a boutique PR & distribution label in Tel Aviv."
        url="/roster"
      />

      <div style={{ padding: "28px 32px 20px" }}>
        <p style={{
          fontFamily: F, fontSize: "9px", fontWeight: 700,
          letterSpacing: "0.4em", textTransform: "uppercase",
          color: "rgba(240,237,232,0.28)", margin: 0,
        }}>
          YEN SOUND · {roster.length} Artists
        </p>
      </div>

      <div
        className="roster-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "32px 20px",
          padding: "8px 32px 80px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {shuffled.map(artist => (
          <ArtistTile
            key={artist.slug}
            artist={artist}
            imageUrl={imageOverrides[artist.slug] || artist.image}
          />
        ))}
      </div>

      <style>{`
        @media (max-width: 700px) {
          .roster-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 32px 16px !important;
            padding: 8px 20px 60px !important;
          }
        }
      `}</style>
    </div>
  );
}
